import * as React from 'react';
import * as AccordionPrimitive from '@radix-ui/react-accordion';

import { OmitStylesComponentProps } from '../../types';
import { cn } from '../../utils/cn';
import { cva, VariantProps } from 'class-variance-authority';

const accordionVariants = cva('rocco-accordion', {
    variants: {
        variant: {
            default: 'w-full',
        },
    },
    defaultVariants: {
        variant: 'default',
    },
});

export const Accordion = React.forwardRef<
    React.ElementRef<typeof AccordionPrimitive.Root>,
    OmitStylesComponentProps<typeof AccordionPrimitive.Root> &
        VariantProps<typeof accordionVariants> & {
            className?: string;
        }
>(({ variant, className, ...props }, ref) => (
    <AccordionPrimitive.Root
        ref={ref}
        className={cn(accordionVariants({ variant }), className)}
        {...props}
    />
));

Accordion.displayName = 'Accordion';
